import React, { useEffect, useMemo, useState } from "react";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import {
  Box,
  TableCell,
  TableRow,
  Select,
  FormControl,
  InputLabel,
  SelectChangeEvent,
  Button,
  MenuItem,
} from "@mui/material";
import useStyles from "../../../../components/pageTitle/styles";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import dayjs from "dayjs";
import {
  getAllReviwsAction,
  setAddReviewResponse,
} from "../../../../store/reducers/reviewSlice";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import ManageReview from "./ManageReview";
// import ComplaintDetailModal from "./ComplaintDetailModal";

// Stage options for filtering
const COMPLAINT_STAGES = [
  "Initiated",
  "Assigned",
  "Data acquiring",
  "Evaluated",
  "Insurance claim",
  "Recovery initiated",
  "Other parties claims",
  "Accept / reject",
  "Settled",
  "Closed",
  "Archived",
  "Rejected",
  "All",
];

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  //   status: string;
}

const ReviewList = ({ activeQuoteId }: { activeQuoteId?: any }) => {
  console.log("activeQuoteId", activeQuoteId);
  const classes = useStyles();
  const { reviews, isAddReviewSuccess } = useSelector(
    (state: any) => state?.review,
  );
  const { userProfile } = useSelector((state: any) => state?.user);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState<any>(null);

  const [filterOption, setFilterOption] = React.useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "",
    orderIn: "asc",
    //   status: "Initiated",
  });

  useEffect(() => {
    if (filterOption) {
      dispatch(getAllReviwsAction(filterOption));
    }
  }, [filterOption]);

  const filteredReviews = useMemo(() => {
    return reviews?.filter((item: any) => {
      if (!activeQuoteId?.quoteId) return true;

      return item.quote_id === activeQuoteId?.quoteId || item.quote_id === null;
    });
  }, [reviews, activeQuoteId]);

  useEffect(() => {
    if (isAddReviewSuccess) {
      dispatch(getAllReviwsAction(filterOption));
      dispatch(setAddReviewResponse(false));
      setShowModal(false);
    }
  }, [isAddReviewSuccess]);

  const handleEditClick = (review: any) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedReview(null);
  };
  const tableHeadings: TableHeading[] = [
    { label: "Action", align: "left" },
    { label: "Lead ID", align: "left" },
    { label: "Customer Name", align: "left" },
    { label: "Source", align: "left" },
    { label: "Date", align: "left" },
    { label: "Review", align: "left" },
    { label: "Service", align: "left" },
    { label: "Rating", align: "left" },
    { label: "How Obtained", align: "left" },
  ];

  const handleAddClick = () => {
    setSelectedReview(null);
    setShowModal(true);
  };

  return (
    <>
      <PageTitle title={"Reviews"} button={"Add"} onClick={handleAddClick} />
      <Box
        sx={{
          bgcolor: "#fff",
          height: {
            xs: "auto",
            sm: reviews?.length > 2 ? "auto" : "20vh",
          },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          padding: "0px",
          overflow: "hidden",
        }}
      >
        <TableDesign
          tableHeadings={tableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={reviews?.length > 0 ? null : null}
          isLoader={false}
          stickyHeader={true}
          filterOption={() => {}}
          setFilterOption={() => {}}
          extraCSS={{
            height: "calc(100%)",
          }}
        >
          {filteredReviews?.length > 0 ? (
            filteredReviews?.map((val: any, idx: number) => (
              <TableRow
                key={val?.complaint_id}
                sx={{
                  cursor: "pointer",
                  marginTop: "10px",
                  padding: "4px !important",
                  borderRadius: "20px !important",
                  height: "20px !important",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                    outline: "2px solid #f0f0f0",
                    borderRadius: "0px !important",
                    outlineOffset: "-2px !important",
                  },
                }}
              >
                <TableCell align="left">
                  <CustomButton
                    title={"Edit"}
                    variant="outlined"
                    onClick={() => handleEditClick(val)}
                  />
                </TableCell>
                <TableCell>{val?.lead_id}</TableCell>
                <TableCell>{val?.customer_name}</TableCell>
                <TableCell>{val?.source_name}</TableCell>
                <TableCell>
                  {val.date
                    ? dayjs(val.date).format(
                        userProfile?.dateFormat
                          ? userProfile?.dateFormat
                          : "DD/MM/YYYY",
                      )
                    : ""}
                </TableCell>
                <TableCell>{val?.title}</TableCell>
                <TableCell>{val?.job_name}</TableCell>
                <TableCell>{val?.rating_title}</TableCell>
                <TableCell>{val?.obtained_from}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={tableHeadings?.length} align="center">
                <Box
                  sx={{
                    height: "60vh",
                    display: "flex",
                    // alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      fontSize: "1rem",
                      color: "#4A4A4A",
                      top: "100px",
                    }}
                  >
                    {`No Data Found!`}
                  </span>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>

      {/* Complaint Detail Modal */}
      {showModal && (
        <ManageReview
          title="Manage Review"
          open={showModal}
          activeQuoteId={activeQuoteId}
          onHide={handleModalClose}
          selectedData={selectedReview}
        />
      )}
    </>
  );
};

export default ReviewList;
